import './globals'
import './component'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@slicejobs/slicejobs-ui/lib/slicejobs-ui.css'
import '@/style/layout.scss'
import '@/style/rewrite-element.scss'
import '@/style/scrollbar.scss'
import '@/style/font.scss'

requires(require.context('@/directive', true, /\.js$/))

Vue.use(ElementUI)
// console.log(require('@slicejobs/slicejobs-ui'))
Vue.use(require('@slicejobs/slicejobs-ui').default)

Vue.prototype.$model = globalThis.$model
Vue.prototype.$util = globalThis.$util
